import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setEmails: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.total = payload.total;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.loading = !!payload.loading;
};

// 详情
export const setEmailDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title || '';
  state.confirm.content = payload.content || '';
  state.confirm.name = payload.name || '';
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
